"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENTAL_PROGRAM_LEASE_TYPES = exports.LEASE_VARIANTS = exports.RENTAL_PROGRAM_TYPES = exports.DO_NOT_RENEW_DAYS_BEFORE_LEASE_END = exports.RENTAL_STATUS = exports.LEASE_END_REASONS = void 0;
exports.LEASE_END_REASONS = Object.freeze({
    // cancelled
    EVICTED: 'evicted',
    VACATED_IN_EVICTIONS: 'vacated_in_evictions',
    ABANDONED_LEASE: 'abandoned_lease',
    EARLY_TERMINATION_CASUALTY_LOSS: 'early_termination_casualty_loss',
    EARLY_TERMINATION_MILITARY: 'early_termination_military',
    EARLY_TERMINATION_MAINTAINANCE_ISSUES: 'early_termination_maintainance_issues',
    EARLY_TERMINATION_CUSTOMER_SERVICE_ISSUES: 'early_termination_customer_service_issues',
    EARLY_TERMINATION_OTHER: 'early_termination_other',
    NEVER_MOVED_IN: 'never_moved_in',
    PURCHASED_HOME: 'purchased_home',
    PURCHASED_HOME_DISPO: 'purchased_home_dispo',
    // completed
    TRANSFERRED_HOMES: 'transferred_homes',
    PURCHASED_OTHER_HOME: 'purchased_other_home',
    PRICE_TOO_HIGH: 'price_too_high',
    CHANGE_OF_ROOMMATES: 'change_of_roommates',
    MOVING_OUT_OF_AREA: 'moving_out_of_area',
    MAINTAINANCE_ISSUES: 'maintainance_issues',
    CUSTOMER_SERVICE_ISSUES: 'customer_service_issues',
    NEED_LARGER_HOME: 'need_larger_home',
    NEED_SMALLER_HOME: 'need_smaller_home',
    DONT_LIKE_NEIGHBORHOOD: 'dont_like_neighborhood',
    PROBLEMS_WITH_NEIGHBORS: 'problems_with_neighbors',
    DO_NOT_RENEW: 'do_not_renew'
});
exports.RENTAL_STATUS = Object.freeze({
    ACTIVE: 'active',
    CANCELED: 'canceled', // move-out before the end of the lease
    COMPLETE: 'complete', // move-out at end of lease
    PENDING: 'pending'
});
// Number of days before lease end when we send a scheduled do not renew notice to the tenant
exports.DO_NOT_RENEW_DAYS_BEFORE_LEASE_END = 60;
exports.RENTAL_PROGRAM_TYPES = {
    UPANDUP: 'upandup',
    VANILLA: 'vanilla'
};
exports.LEASE_VARIANTS = {
    STANDARD: 'standard',
    KCPOA: 'kcpoa'
};
exports.RENTAL_PROGRAM_LEASE_TYPES = {
    [exports.RENTAL_PROGRAM_TYPES.UPANDUP]: 'upandup_lease',
    [exports.RENTAL_PROGRAM_TYPES.VANILLA]: 'vanilla_lease'
};
